import React from "react";
import { connect } from "react-redux";
import * as types from "../../../constants/actionTypes";
import * as d from "../../../reducers/domainReducer";
import Spinner from "../../common/spinner";
import Covid19ScreenerSurvey from "./Covid19ScreenerSurvey";
import SelectPatient from '../../common/SelectPatient';
import { logUI } from '../../../api/andyliticsApi';
import { getURLPath } from '../../../helpers/Tools';

class Covid19Screener extends React.Component {
    constructor(props) {
        super(props);
        this.state = { userSelected: false };
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Covid19Screener.ComponentDidMount", new Date(), getURLPath());
    }

    onUserSwitched = (userSelected, index) => {
        window.userToSwitch = userSelected;
        this.setState({ userSelected });
        this.props.switchToMyChartUser(userSelected, index);
    }

    render() {
        const {
            hasMyChart, age, myProxies, isProxyUser, currentUser, serverData, switchingProxyUser, isProxyAvailable, proxyListFailure, proxyListLoaded
        } = this.props;
        const userAge = isProxyUser ? currentUser && currentUser.ageYears : age;

        const showCovid19ScreenerSurvey = ((this.state.userSelected && !switchingProxyUser) || (!this.state.userSelected && !isProxyAvailable));

        return (
            <React.Fragment>
                {((!proxyListFailure && !proxyListLoaded || switchingProxyUser) && !showCovid19ScreenerSurvey) && <Spinner />}
                {!this.state.userSelected && isProxyAvailable &&
                    <div className="container-fluid body-content check-vaccine-eligibility">
                        <div className="row">
                            <div className="col-12 maxWidth-content">
                                <SelectPatient
                                    steptitle="Select Patient"
                                    myProxies={myProxies}
                                    hasMychart={hasMyChart}
                                    currentUser={currentUser}
                                    switchToMyChartUser={this.onUserSwitched}
                                    isAdult={userAge && userAge > 17}
                                    userSelected={this.state.userSelected}
                                    onUserSelected={userSelected => this.setState({ userSelected })}
                                    shouldHideContinueButton
                                    activityCode="MBHWeb.UI.Covid19Screener.AddDependent.Clicked"
                                    message={"Who is this for?"}
                                    iconLeftClass={"svg-schedule-color"}
                                    serverData={serverData} />
                            </div>
                        </div>
                    </div>}
                {
                    showCovid19ScreenerSurvey && <Covid19ScreenerSurvey />
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const pl = [];
    if (state.domain.pl) {
        state.domain.pl.forEach((proxy) => {
            pl.push(d.hydrateProxyUser(proxy));
        });
    }

    return {
        hasMyChart: state.domain.hm,
        age: state.domain.age,
        myProxies: pl,
        isProxyUser: state.domain.ip,
        currentUser: d.hydrateProxyUser(state.domain.cu),
        proxyCurrentUser: state.memberships.currentUser,
        switchingProxyUser: state.memberships.switchingProxyUser,
        serverData: state.session.serverData,
        proxyListFailure: state.memberships.proxyListFailure,
        proxyListLoaded: state.memberships.proxyListLoaded,
        isProxyAvailable: state.domain.hm && pl && pl.length > 1 ? true : false,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        technicalHelpDeskHours: state.session.serverData ? state.session.serverData.technicalHelpDeskHours : ""
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        switchToMyChartUser: (user, index) => {
            dispatch({ type: types.SWITCH_USER_SAGA, user, index });
            dispatch({ type: types.SWITCH_TO_PHARMACY_USER, pharmacyUser: null });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Covid19Screener);